/**
 * @ngdoc Directive
 * @name vrm-sortable
 * @example
 *
 * <vrm-sortable/>
 *
 */

import {attributeValueComparator} from '@/utils/attributes';

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmSortable', vrmSortable);

    /* @ngInject */
    function vrmSortable() {

        var definition = {
            restrict: 'E',
            transclude: true,
            scope: true,
            link: link,
            controller: controller,
        };

        return definition;

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         */
        function link($scope, $element, $attr, $controller, $transclude) {
            //Keep transcluded content in same scope
            $transclude($scope, function(clone, $scope) {
                $element.append(clone);
            });
        }

        /* @ngInject */
        function controller($scope) {
            // Initialize the way the table is sorted, unless the parent scope initialized sortType already
            if (!$scope.sortType) {
                $scope.sortType = 'name';
            }

            // The sort order of the table
            $scope.sortReverse = false;

            // Is called for every table head. Each instance checks if the table is sorted on its value. Returns classname.
            $scope.isAscendingOrDescending = function(input){
                if(input === $scope.sortType){
                    if($scope.sortReverse === false ){
                        return 'vrm-table__sort--ascending';
                    } else {
                        return 'vrm-table__sort--descending';
                    }
                }
            };

            $scope.comparator = function(v1, v2) {
                return attributeValueComparator(v1.value, v2.value);
            };

            // Internally keep track of the last sorted value.
            var lastSortedValue;

            // Set the value to sort the table with
            $scope.sortOnType = function(input) {
                $scope.sortType = input;
                if(lastSortedValue == input) {
                    $scope.sortReverse = !$scope.sortReverse;
                } else {
                    $scope.sortReverse = false;
                }
                lastSortedValue = input;
            };
        }
    }
})();
